import React from 'react'

/**
 * Inset horizontal separator between teacher-profile sections.
 * The line stops short of the unified container's left/right edges
 * so the divider doesn't bleed into the card border.
 *
 * Each section renders this as its FIRST child (gated by the same
 * "no data" early return as the section itself), so the divider only
 * appears when the section actually has content to show. The hero
 * (TeacherDetails) is the exception — it always sits at the top of
 * the unified container without a divider above it.
 */
const SectionDivider = () => (
  <div className="px-5 lg:px-10">
    <div className="border-t border-grey-300" />
  </div>
)

export default SectionDivider
